import ImageSlider from "../../../ImageSlider/ImageSlider";
import CabinInfo from "./CabinInfo/CabinInfo";
interface ICabinCard {
  cabinDetails: any;
}

const CabinCard: React.FC<ICabinCard> = ({ cabinDetails }) => {

  if (!cabinDetails?.items?.length) {
    return <span className="pl-5 no-rooms">Loading...</span>
  }

  return (
    <div className="flex flex-col gap-3 w-100">
      {cabinDetails?.items?.map((room: any, index: number, arr: any) => {
        return (
          <div key={index} className={`${index === arr.length - 1 ? "" : "border-b pb-3"}`}>
            <div className="flex justify-around gap-3 w-100">
              <div className="flex flex-col gap-3">
                <span className="text-uppercase text-center text-xl font-bold underline underline-offset-4 text-muted">{room?.roomCategory?.name}</span>
                <div className="img-wrapper w-[310px] h-[200px]">
                  <ImageSlider
                    controls
                    slide
                    fade={false}
                    indicators={false}
                    interval={5000}
                    imgDataArray={room?.roomCategory?.images?.map(
                      (imgData: any) => `https://images.cordeliacruises.com${imgData?.src}`
                    )}
                  />
                </div>
                <div className="flex justify-center gap-3 text-base font-bold">
                    <span className="text-muted">Guests:</span>
                    {!!room?.guests?.adults && <span className="text-success">{room?.guests?.adults}{`${room?.guests?.adults > 1 ? ' Adults' : ' Adult'}`}</span>}
                    {!!room?.guests?.children && <span className="text-primary">{room?.guests?.children}{`${room?.guests?.children > 1 ? ' Children' : ' Child'}`}</span>}
                    {!!room?.guests?.infants && <span className="text-danger">{room?.guests?.infants}{`${room?.guests?.infants > 1 ? ' Infants' : ' Infant'}`}</span>}
                </div>
              </div>
              <div className="flex flex-col gap-2 w-[40vw] mt-[30px]">
                <CabinInfo roomInfo={room?.roomCategory} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CabinCard;
